import { render, staticRenderFns } from "./PhysicalCount.vue?vue&type=template&id=2267a0df&"
import script from "./PhysicalCount.vue?vue&type=script&lang=js&"
export * from "./PhysicalCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports